const languages = {

    en_us: {
        report: {
            myreport: 'My Report',
            args:"Args",
            his:"History",
            search:"Search"
        }
    },
    zh_cn: {
        report:{
            myreport: '我的报表',
            args:"报表参数",
            his:"导入日志",
            search:"查询"
        }
    }


}
export default languages;